module.exports = __webpack_public_path__ + "img/Cell-Essence_Film1.c0320045.jpg";